module.exports = __webpack_public_path__ + "img/app_store@3x.506b5750.png";